// extracted by mini-css-extract-plugin
export default {"paper":"paper__PF-MG","message":"message__5ZXfy","actions":"actions__L0-8T"};